module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Adresy e-mail\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.import'
        })
      }
    }
  }, [_vm._v("Importuj adresy e-mail")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "file_download",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.export-emails'
        })
      }
    }
  }, [_vm._v("Eksportuj adresy e-mail")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.dashboard'
        })
      }
    }
  }, [_vm._v("Grupy adresów")])], 1), _vm._v(" "), _c('emails-list')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fcbbfd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/Dashboard.vue
// module id = 241
// module chunks = 0